// Shared visual tokens for admin surfaces.
//
// Extracted verbatim from AdminPortal.jsx so the Global Admin dashboard analytics
// section shares one source of truth instead of duplicating the literals. Values are
// unchanged — this is a move, not a redesign.
//
// Purely presentational: colours, radii, shadows. No behaviour.

// ─── Palette ─────────────────────────────────────────────────────────────────
export const C = {
  navy:   '#072146',
  green:  '#00C853',
  bg:     '#EAF0F6',
  border: '#e2e8f0',
  muted:  '#64748b',
};

// Stable per-index colours for entity avatars and chart series.
export const AVATAR_PALETTE = ['#072146', '#0891B2', '#059669', '#7C3AED', '#C2410C', '#B45309'];

export function entityColor(idx) {
  return AVATAR_PALETTE[idx % AVATAR_PALETTE.length];
}

// ─── Surfaces & controls ─────────────────────────────────────────────────────
export const btnBase  = { borderRadius: 2, textTransform: 'none', fontWeight: 700 };
export const ctaGreen = { bgcolor: C.green, color: '#1a1a1a', '&:hover': { bgcolor: '#00b048' } };
export const ctaNavy  = { bgcolor: C.navy,  color: '#ffffff', '&:hover': { bgcolor: '#0a326d' } };

// Cards use elevation={0} plus this — never MUI's default shadow.
export const cardBase = {
  borderRadius: 3,
  border: `1px solid ${C.border}`,
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  transition: 'box-shadow 0.2s, transform 0.2s',
  '&:hover': { boxShadow: '0 6px 20px rgba(0,0,0,0.10)', transform: 'translateY(-2px)' },
};

// A card that is a static readout rather than a clickable target: same surface,
// no hover lift (a KPI tile that rises on hover reads as a button).
export const cardStatic = {
  borderRadius: 3,
  border: `1px solid ${C.border}`,
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
};

// ─── Analytics bucket colours ────────────────────────────────────────────────

export const ANALYTICS_COLORS = {
  // Layer 1 — account type (charted as lines)
  microsoft:     '#0a326d',   // theme primary navy — the "official account"
  guest:         '#7C3AED',   // AVATAR_PALETTE violet — far from navy AND from red
  // Layer 2 — product identity (KPI card accents only, no delta arrows nearby,
  // so a warm hue is safe here in a way it is not on Layer 1)
  cmsOnly:       '#0891B2',
  immersiveOnly: '#C2410C',
  bothProducts:  '#059669',
};
